import _slicedToArray from "/src/main/react/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/pages/UpdateProgram.js";
import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { Grid, Paper, Typography, Button, TextField, Select, MenuItem } from '@material-ui/core';
import { EntityInfo, SimpleSnackbar, Loading } from '../common';
import queryString from 'query-string';
import Util from '../../util/Util';
import TpicPage from './TpicPage';
import { BASE_URIS, ENTITY_MESSAGE_TYPES, Q_STRING, TPIS_PARAMS } from "../domain/constants";
import { retrieveFromQueryString } from "../../util/QueryStringUtil";
import { fillInEntityInfo, loadDisplayInfo } from "../../util/APIUtil";

// TODO: Undupe this code
const styles = theme => ({
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    maxWidth: '80vw',
    minWidth: '80vw'
  },
  tabs: {
    backgroundColor: theme.palette.background.paper,
    minWidth: '80%',
    maxWidth: '80%',
    margin: 0
  },
  inputStyle: {
    margin: '5px',
    padding: '5px'
  }
});
class UpdateProgram extends TpicPage {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleChange", name => event => {
      this.setState({
        [name]: event.target.value
      });
    });
    _defineProperty(this, "handleLocalizedChange", (name, field, index) => event => {
      // Get the localized field (i.e. localizedTitle or localizedDescription
      const localizedField = this.state[name];

      // Get the object itself
      let object = localizedField[index];

      // Change the object
      object[field] = event.target.value;

      // Replace the object in the collection
      localizedField[index] = object;

      // Replace the collection in the state
      this.setState({
        [name]: localizedField
      });
    });
    const querystringValues = queryString.parse(this.props.location.search);
    this.state = {
      entityId: props.entityId != null ? props.entityId : retrieveFromQueryString(Q_STRING.ENTITY_ID, querystringValues),
      entityMessageTitle: null,
      entityMessageDescription: null,
      entityMessageType: null,
      entityMessageLocalizedTitles: [],
      entityMessageLocalizedDescriptions: [],
      messageTypes: [],
      loaded: true,
      // entityInfo fields
      title: null,
      subtitle: null,
      adiId: null,
      merlinId: null,
      type: null,
      lookupComplete: false
    };
    loadDisplayInfo(this);
    this.snackbar = null;
    this.setSnackbarRef = element => {
      this.snackbar = element;
    };
    fillInEntityInfo(this);
    this.fillInExistingEntityMessage();
  }
  reset() {
    this.state.entityMessageTitle = null;
    this.state.entityMessageDescription = null;
    this.state.entityMessageLocalizedTitles = [];
    this.state.entityMessageLocalizedDescriptions = [];
    this.state.loaded = true;
    this.fillInExistingEntityMessage();
    this.forceUpdate();
    loadDisplayInfo(this);
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.lookupComplete === false && (this.state.entityId !== prevState.entityId || this.state.title !== prevState.title || this.state.adiId !== prevState.adiId || this.state.merlinId !== prevState.merlinId || this.state.subtitle !== prevState.subtitle)) {
      fillInEntityInfo(this);
      this.fillInExistingEntityMessage();
      loadDisplayInfo(this);
    }
  }
  render() {
    const classes = this.props.classes;
    const _this$state = this.state,
      entityId = _this$state.entityId,
      entityMessageTitle = _this$state.entityMessageTitle,
      entityMessageDescription = _this$state.entityMessageDescription,
      entityMessageType = _this$state.entityMessageType,
      entityMessageLocalizedTitles = _this$state.entityMessageLocalizedTitles,
      entityMessageLocalizedDescriptions = _this$state.entityMessageLocalizedDescriptions,
      loaded = _this$state.loaded,
      title = _this$state.title,
      adiId = _this$state.adiId,
      merlinId = _this$state.merlinId,
      subtitle = _this$state.subtitle,
      type = _this$state.type;
    let key = "".concat(entityId, "+").concat(title, "+").concat(adiId, "+").concat(merlinId, "+").concat(subtitle, "+").concat(type);
    return /*#__PURE__*/React.createElement("div", {
      id: "grid-container",
      className: classes.centeredContainer,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 108,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(SimpleSnackbar, {
      ref: this.setSnackbarRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 109,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      item: true,
      alignContent: "center",
      direction: "column",
      spacing: 2,
      justify: "space-around",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 110,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 112,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(EntityInfo, {
      key: key,
      title,
      adiId,
      merlinId,
      subtitle,
      type,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 113,
        columnNumber: 25
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      spacing: 2,
      alignItems: "center",
      alignContent: "center",
      justify: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 117,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Paper, {
      style: {
        overflow: 'hidden',
        width: '100%',
        margin: '15px',
        padding: '15px'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 118,
        columnNumber: 25
      }
    }, loaded === false && /*#__PURE__*/React.createElement(Loading, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 120,
        columnNumber: 29
      }
    }), loaded === true && /*#__PURE__*/React.createElement(Fragment, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 123,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignItems: "center",
      alignContent: "space-around",
      justify: "space-around",
      spacing: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 125,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 2,
      md: 2,
      lg: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 127,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 128,
        columnNumber: 41
      }
    }, "Title")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 10,
      md: 10,
      lg: 10,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 130,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      id: "entityMessageTitle",
      value: entityMessageTitle,
      fullWidth: true,
      variant: "outlined",
      styles: classes.inputStyle,
      onChange: this.handleChange('entityMessageTitle'),
      "aria-describedby": "entityMessageTitle-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 131,
        columnNumber: 41
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignItems: "center",
      alignContent: "space-around",
      justify: "center",
      spacing: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 138,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 2,
      md: 2,
      lg: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 140,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 141,
        columnNumber: 41
      }
    }, "Description")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 10,
      md: 10,
      lg: 10,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 143,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      id: "entityMessageDescription",
      value: entityMessageDescription,
      fullWidth: true,
      variant: "outlined",
      styles: classes.inputStyle,
      onChange: this.handleChange('entityMessageDescription'),
      "aria-describedby": "entityMessageDescription-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 144,
        columnNumber: 41
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignItems: "center",
      alignContent: "space-around",
      justify: "center",
      spacing: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 152,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 2,
      md: 2,
      lg: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 154,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 155,
        columnNumber: 41
      }
    }, "Type")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 10,
      md: 10,
      lg: 10,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 157,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Select, {
      id: "entityMessageType",
      value: entityMessageType,
      variant: "outlined",
      styles: classes.inputStyle,
      displayEmpty: true,
      onChange: this.handleChange('entityMessageType'),
      "aria-describedby": "entityMessageType-field",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 158,
        columnNumber: 41
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      value: null,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 163,
        columnNumber: 45
      }
    }, "Default"), this.state.messageTypes != null && this.state.messageTypes.length !== 0 && this.state.messageTypes.map(messageType => /*#__PURE__*/React.createElement(MenuItem, {
      value: messageType,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 165,
        columnNumber: 49
      }
    }, messageType))))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      spacing: 2,
      direction: "column",
      alignContent: "center",
      alignItems: "center",
      justify: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 171,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 173,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 174,
        columnNumber: 41
      }
    }, "Localized Titles")), entityMessageLocalizedTitles != null && entityMessageLocalizedTitles.length !== 0 && entityMessageLocalizedTitles.map((item, index) => this.getRow('entityMessageLocalizedTitles', 'title', index, entityMessageLocalizedTitles, classes)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 182,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      color: "primary",
      onClick: () => {
        this.addRowToCollection(entityMessageLocalizedTitles, 'title', 'entityMessageLocalizedTitles');
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 183,
        columnNumber: 41
      }
    }, " + "))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      spacing: 2,
      direction: "column",
      alignContent: "center",
      alignItems: "center",
      justify: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 189,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 191,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 192,
        columnNumber: 41
      }
    }, "Localized Descriptions")), entityMessageLocalizedDescriptions != null && entityMessageLocalizedDescriptions.length !== 0 && entityMessageLocalizedDescriptions.map((item, index) => this.getRow('entityMessageLocalizedDescriptions', 'description', index, entityMessageLocalizedDescriptions, classes)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 200,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      color: "primary",
      onClick: () => {
        this.addRowToCollection(entityMessageLocalizedDescriptions, 'description', 'entityMessageLocalizedDescriptions');
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 201,
        columnNumber: 41
      }
    }, "+"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignItems: "center",
      alignContent: "center",
      justify: "space-around",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 207,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 209,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      color: "primary",
      onClick: () => {
        this.submitProgramUpdateRequest(false);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 210,
        columnNumber: 41
      }
    }, "Submit")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 214,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      color: "primary",
      style: {
        color: 'red'
      },
      onClick: () => {
        this.submitProgramUpdateRequest(true);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 215,
        columnNumber: 41
      }
    }, "Remove All Overrides"))))))));
  }
  getRow(collectionName, valueName, index, collection, classes) {
    let name = valueName === 'title' ? 'Title' : 'Description';
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      spacing: 2,
      alignContent: "center",
      alignItems: "center",
      justify: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 233,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 1,
      md: 1,
      lg: 1,
      alignContent: "flex-end",
      alignItems: "flex-end",
      justify: "flex-end",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 235,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 236,
        columnNumber: 21
      }
    }, "Locale")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 2,
      md: 2,
      lg: 2,
      alignContent: "center",
      alignItems: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 238,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      id: collectionName + '-locale-' + index,
      value: collection[index]['locale'],
      fullWidth: true,
      variant: "outlined",
      styles: classes.inputStyle,
      onChange: this.handleLocalizedChange(collectionName, 'locale', index),
      "aria-describedby": collectionName + "-locale-field-" + index,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 239,
        columnNumber: 21
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 1,
      md: 1,
      lg: 1,
      alignContent: "flex-end",
      alignItems: "flex-end",
      justify: "flex-end",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 245,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 246,
        columnNumber: 21
      }
    }, name)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 7,
      md: 7,
      lg: 7,
      alignContent: "center",
      alignItems: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 248,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      id: collectionName + '-' + valueName + '-' + index,
      value: collection[index][valueName],
      fullWidth: true,
      variant: "outlined",
      styles: classes.inputStyle,
      onChange: this.handleLocalizedChange(collectionName, valueName, index),
      "aria-describedby": collectionName + "-" + valueName + "-field-" + index,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 249,
        columnNumber: 21
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 1,
      md: 1,
      lg: 1,
      alignContent: "center",
      alignItems: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 255,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      color: "primary",
      onClick: () => {
        this.removeLocalizedFieldAtIndex(collectionName, index);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 256,
        columnNumber: 21
      }
    }, "-")));
  }
  submitProgramUpdateRequest(isDelete) {
    this.state.loaded = false;
    this.forceUpdate();
    const _this$state2 = this.state,
      entityId = _this$state2.entityId,
      entityMessageTitle = _this$state2.entityMessageTitle,
      entityMessageDescription = _this$state2.entityMessageDescription,
      entityMessageType = _this$state2.entityMessageType,
      entityMessageLocalizedTitles = _this$state2.entityMessageLocalizedTitles,
      entityMessageLocalizedDescriptions = _this$state2.entityMessageLocalizedDescriptions;
    let uri = "".concat(BASE_URIS.prefix).concat(BASE_URIS.updateProgram, "?").concat(TPIS_PARAMS.ENTITY_ID, "=").concat(entityId);
    if (isDelete) {
      uri += TPIS_PARAMS.DELETE_ENTITY_MESSAGE;
    } else {
      uri += (entityMessageTitle != null ? "&".concat(TPIS_PARAMS.TITLE, "=").concat(encodeURIComponent(entityMessageTitle)) : '') + (entityMessageDescription != null ? "&".concat(TPIS_PARAMS.DESCRIPTION, "=").concat(encodeURIComponent(entityMessageDescription)) : '') + (entityMessageType != null ? "&".concat(TPIS_PARAMS.TYPE, "=").concat(encodeURIComponent(entityMessageType)) : '');
      for (let x of entityMessageLocalizedTitles) {
        const locale = x['locale'];
        const title = x['title'];
        if (title != null) {
          const encodedKey = encodeURIComponent("localizedTitles[".concat(locale, "]"));
          const encodedValue = encodeURIComponent(title);
          uri += "&".concat(encodedKey, "=").concat(encodedValue);
        }
      }
      for (let x of entityMessageLocalizedDescriptions) {
        const locale = x['locale'];
        const description = x['description'];
        if (description != null) {
          const encodedKey = encodeURIComponent("localizedDescriptions[".concat(locale, "]"));
          const encodedValue = encodeURIComponent(description);
          uri += "&".concat(encodedKey, "=").concat(encodedValue);
        }
      }
    }
    Util.fetchWithRedirect(uri, 'POST', this.props).then(resp => {
      // If it was successful, the status field will contain a response object
      // If it was unsuccessful, the status field will contain a response status code
      if (typeof resp.status === 'object') {
        Util.openSnackbar("Program update request was successful", this.snackbar);
        this.reset();
      } else {
        // failure
        Util.openSnackbar("Program update request failed", this.snackbar);
        this.state.loaded = true;
        this.forceUpdate();
      }
    });
  }
  fillInExistingEntityMessage() {
    this.state.loaded = false;
    this.forceUpdate();
    const _this$state3 = this.state,
      entityId = _this$state3.entityId,
      merlinId = _this$state3.merlinId,
      title = _this$state3.title,
      type = _this$state3.type;
    let uri = BASE_URIS.prefix + BASE_URIS.listPrograms;
    if (entityId != null) {
      uri += "?".concat(TPIS_PARAMS.ENTITY_ID, "=").concat(entityId);
    } else if (merlinId != null) {
      uri += "?".concat(TPIS_PARAMS.ENTITY_ID, "=").concat(merlinId);
    } else if (title != null) {
      uri += "?".concat(TPIS_PARAMS.TITLE, "=").concat(title);
    } else if (title != null) {
      uri += "?".concat(TPIS_PARAMS.TYPE, "=").concat(type);
    } else {
      console.log("couldn't determine lookup");
      Util.openSnackbar("Couldn't look up existing Entity Message. This page may display as blank", this.snackbar);
    }
    uri += TPIS_PARAMS.INCLUDE_ENTITY_MESSAGES;
    Util.fetchWithRedirect(uri, 'GET', this.props).then(resp => {
      // If it was successful, the content field will be populated
      if (resp.content != null && resp.content.length > 0 && resp.content[0] != null) {
        console.dir(resp);
        // there should only be one program, we searched by programId
        const overrides = resp.content[0]['overrides'];
        if (overrides != null && overrides['entityMessages'] != null && overrides['entityMessages'].length > 0) {
          const entityMessages = overrides['entityMessages'];

          // I'm not sure if it's intended or not, but the listPrograms API returns all entityMessages every
          // time you call it, regardless of the id you call it for. We need to loop through them to get the
          // one we want. This should be a backwards-compatible solution if, in the future, we decide to change that
          let message;
          for (let em of entityMessages) {
            const emEntityId = em['entityId'];
            if (emEntityId === entityId) {
              message = em;
              break;
            }
          }
          if (message == null) {
            console.log("No EntityMessage override found for this entityId");
          } else {
            const localizedTitles = message['localizedTitles'];
            const localizedDescriptions = message['localizedDescriptions'];
            const type = message['entityMessageType'];
            let entityMessageTitle;
            let entityMessageDescription;
            let entityMessageLocalizedTitles = [];
            let entityMessageLocalizedDescriptions = [];
            if (localizedTitles != null) {
              for (const _ref of Object.entries(localizedTitles)) {
                var _ref2 = _slicedToArray(_ref, 2);
                const locale = _ref2[0];
                const title = _ref2[1];
                if (locale === 'en') {
                  entityMessageTitle = title;
                } else {
                  entityMessageLocalizedTitles.push({
                    locale,
                    title
                  });
                }
              }
            }
            if (localizedDescriptions != null) {
              for (const _ref3 of Object.entries(localizedDescriptions)) {
                var _ref4 = _slicedToArray(_ref3, 2);
                const locale = _ref4[0];
                const description = _ref4[1];
                if (locale === 'en') {
                  entityMessageDescription = description;
                } else {
                  entityMessageLocalizedDescriptions.push({
                    locale,
                    description
                  });
                }
              }
            }
            this.state.entityMessageTitle = entityMessageTitle;
            this.state.entityMessageDescription = entityMessageDescription;
            this.state.entityMessageType = type;
            this.state.entityMessageLocalizedTitles = entityMessageLocalizedTitles;
            this.state.entityMessageLocalizedDescriptions = entityMessageLocalizedDescriptions;
            console.dir(this.state);
          }
        }
      } else {
        // failure
        console.log("resp.content was null");
        Util.openSnackbar("Couldn't find any Entity Messages for this Program", this.snackbar);
      }
      this.state.loaded = true;
      this.forceUpdate();
    });
  }
  addRowToCollection(collection, valueName, collectionName) {
    let obj = {
      locale: ''
    };
    obj[valueName] = '';
    collection.push(obj);
    this.setState({
      [collectionName]: collection
    });
  }
  removeLocalizedFieldAtIndex(collectionName, index) {
    const collection = this.state[collectionName];
    collection.splice(index, 1);
    this.setState({
      [collectionName]: collection
    });
  }
}
export default withStyles(styles)(withRouter(UpdateProgram));